import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {timer} from 'rxjs';
import {MobileService} from 'src/app/core/page/mobile.service';

@Component({
  selector: 'oph-input-inside-label',
  templateUrl: './oph-input-inside-label.component.html',
  styleUrls: ['./oph-input-inside-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OphInputInsideLabelComponent implements AfterViewInit, OnInit {
  @Input() set value(value: string) {
    this.formInput.setValue(value);
  }
  @Input() set control(control: FormControl | null) {
    this.internalControl = control || this.formInput;
  }
  private _maxLength: number;
  @Input() set maxLength(val: number) {
    this._maxLength = val;
    this.updateValidators();
  }
  get maxLength(): number {
    return this._maxLength;
  }
  private _minLength: number = 0;
  @Input() set minLength(val: number) {
    if (val !== undefined && val !== null) {
      this._minLength = val;
    }
    this.updateValidators();
  }
  get minLength(): number {
    return this._minLength;
  }
  @Input() name = 'oph-input-inside-label';
  @Input() invalid: boolean;
  @Input() label: string;
  @Input() inputType: string;
  @Input() fontSize: number;
  @Input() width: number;
  @Input() paddingRight: number;
  @Input() defaultFocus: boolean;
  @Input() borderColorHex: string;
  @Input() labelColorHex: string;
  @Input() valueColorHex: string;
  @Input() backgroundColorHex: string;
  @Input() backgroundColor: string;
  @Input() disabled: boolean = false;
  @Input() inputStyle: Object;
  @Input() placeholder = '';
  @Input() hideLabel: boolean = false;
  @Input() charCounterThreshold?: number;

  @Output() valueChange = new EventEmitter<string>();
  @Output() inputFocus = new EventEmitter<boolean>();

  @ViewChild('input') input: ElementRef;

  formInput = new FormControl(null);
  inputFocusClass: boolean;
  internalControl = this.formInput;

  constructor(private mobileService: MobileService) {}

  ngOnInit(): void {
    this.updateValidators();
  }

  private updateValidators() {
    const validators = [];
    if (this._minLength != null) {
      validators.push(Validators.minLength(this._minLength));
    }
    if (this._maxLength != null) {
      validators.push(Validators.maxLength(this._maxLength));
    }
    this.internalControl.setValidators(validators);
    this.internalControl.updateValueAndValidity();
  }

  ngAfterViewInit() {
    if (this.defaultFocus) {
      if (this.mobileService.isMobilePlatform()) return;
      timer(500).subscribe(() => this.input.nativeElement.focus());
    }
  }

  onInput(value: string) {
    this.valueChange.emit(value);
  }

  get charCount(): number {
    return this.internalControl?.value?.length || 0;
  }

  onFocus() {
    this.inputFocusClass = true;
    this.inputFocus.emit(true);
  }
}
